@if (status(); as currentStatus) {
  <button
    type="button"
    class="flex items-center justify-center w-8 h-8 rounded-md hover:bg-third-level"
    [style.color]="color()"
    [pTooltip]="label()"
    tooltipPosition="left"
    [attr.aria-label]="label()"
    [attr.data-testid]="'attribute-consistency-status-' + testId()"
    [attr.data-status]="currentStatus"
    (click)="onDetailsRequested()"
  >
    <i class="pi text-lg leading-none" [ngClass]="icon()"></i>
  </button>
}
